export default __webpack_public_path__ + "static/custom-img-3-bcc18e15592d976ad198eb2990c6db63.webp";